import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-template-somente-corpo',
  templateUrl: './template-somente-corpo.component.html',
  styleUrls: ['./template-somente-corpo.component.css']
})
export class TemplateSomenteCorpoComponent implements OnInit {

  public constructor() {
  }

  ngOnInit() {
  }

}
